import { fetchUtils } from "ra-core";

export const apiKey = "sb_publishable_z25iAu41qXRxSm0sI8iA3F_SIlrsgX7";
const apiURL: string = `${location.origin}/api`;
export const restURL: string = `${apiURL}/rest/v1`;
export const authURL: string = `${apiURL}/auth/v1`;
export const storageURL: string = `${apiURL}/storage/v1`;

export const httpClient = async (url: string, options: any = {}) => {
    if (!options.headers) options.headers = new Headers({});
    options.headers.set("apiKey", apiKey);
    const token = localStorage.getItem("access_token");
    if (token !== null) {
        options.user = {
            authenticated: true,
            // This ensures that users are identified correctly and that RLS can be applied
            token: `Bearer ${token}`,
        };
    }
    return fetchUtils.fetchJson(url, options);
};

export const refreshAuth = () => {
    const token = localStorage.getItem("access_token");
    const accessToken = token ? parseJwt(token) : undefined;
    if (accessToken !== undefined && accessToken.exp < Date.now() / 1000) {
        // This function will fetch the new tokens from the authentication service and update them in localStorage
        return refreshAccessToken(localStorage.getItem("refresh_token")!);
    }
    return Promise.resolve();
}

async function refreshAccessToken(refreshToken: string): Promise<void> {
    const { access_token, refresh_token } = await fetch(`${apiURL}/auth/v1/token?grant_type=refresh_token`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
    }).then(x => x.json());
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token)
}

export const imageURL = (path: string, dimensions?: { h: number; w: number }) => {
    if (path.startsWith("http")) {
        return path;
    } else {
        return `${apiURL}/storage/v1/render/image/public/images/${path}?resize=cover${dimensions ? `&height=${dimensions.h}&width=${dimensions.w}` : ""}`;
    }
};

export function parseJwt(token: string): AccessToken {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split("")
            .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join("")
    );
    const parsed = JSON.parse(jsonPayload) as AccessToken;
    return { ...parsed, id: parsed.app_metadata.access[0] };
}

export interface AccessToken {
    id: number;
    sub: string;
    fullname: string;
    avatar: string;
    iat: number;
    exp: number;
    role: string;
    iss: string;
    aud: string;
    email: string;
    phone: string;
    app_metadata: { access: number[], claims_admin: boolean };
    user_metadata: { email_verified: boolean, picture: string, full_name: string }
}